import request from '@/utils/request'
export function fetchList(data) {
  return request({
    url:'/order/list',
    method:'post',
    data:data
  })
}

export function getItems(data) {
  return request({
    url:'/order/get/items',
    method:'post',
    data:data
  })
}


export function fetchLogList(data) {
  return request({
    url:'/order/get/log',
    method:'post',
    data:data
  })
}

export function addOrder(data) {
  return request({
    url:'/order/b/add',
    method:'post',
    data: data
  })
}

export function closeOrder(data) {
  return request({
    url:'/order/batch',
    method:'post',
    data: data
  })
}

export function batchAddOrder(data) {
  return request({
    url:'/order/batch/add',
    method:'post',
    data: data
  })
}

export function deleteOrder(data) {
  return request({
    url:'/order/batch',
    method:'post',
    data: data
  })
}

export function deliveryOrder(data) {
  return request({
    url:'/order/batch/list',
    method:'post',
    data:data
  });
}

export function getOrderDetail(data) {
  return request({
    url:'/order/get',
    method:'post',
    data: data
  });
}

export function updateReceiverInfo(data) {
  return request({
    url:'/order/edit',
    method:'post',
    data: data
  })
}

export function updateMoneyInfo(data) {
  return request({
    url:'/order/edit',
    method:'post',
    data: data
  })
}

export function updateOrderNote(data) {
  return request({
    url:'/order/edit',
    method:'post',
    data: data
  })
}

export function exchangeOrder(data) {
  return request({
    url:'/return/apply/exchange',
    method:'post',
    data: data
  })
}

export function getReason() {
  return request({
    url:'/return/apply/reason/get/list',
    method:'post'
  })
}

export function noticeMall(data) {
  return request({
    url:'/order/notice/mall',
    method:'post',
    data: data
  })
}

export function sendOrderMsg(data) {
  return request({
    url:'/order/msg/send',
    method:'post',
    data: data
  })
}

export function getOrderSecret(data) {
  return request({
    url:'/callback/v1/order/get/' + data,
    method:'get'
  })
}

export function createOrderSecret(secret,data) {
  return request({
    url:'/web/order/create/' + secret,
    method:'post',
    data: data
  })
}

export function queryBillHistoryList(secret,data) {
  return request({
    url:'/web/v1/bill/history/list/' + secret,
    method:'post',
    data: data
  })
}

export function delBillHistory(secret,data) {
  return request({
    url:'/web/order/revoke/' + secret,
    method:'post',
    data: data
  })
}

export function lossBillHistory(secret,data) {
  return request({
    url:'/web/order/loss/' + secret,
    method:'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/order.js